import { render, staticRenderFns } from "./InformationForm.vue?vue&type=template&id=81b5ba24&scoped=true&lang=html&"
import script from "./InformationForm.vue?vue&type=script&lang=js&"
export * from "./InformationForm.vue?vue&type=script&lang=js&"
import style0 from "./InformationForm.vue?vue&type=style&index=0&id=81b5ba24&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b5ba24",
  null
  
)

export default component.exports